'use client';

import type { LegalDocumentContentProps } from './legal-document-content';
import { LegalDocumentContent } from './legal-document-content';
import { SwipableDialog } from './swipable-dialog';

export type LegalDocumentDialogProps = LegalDocumentContentProps & {
  open: boolean;
  onClose(): void;
  /** Accessible name of the dialog, available before the document has loaded. */
  label: string;
  title?: string;
};

export function LegalDocumentDialog({
  open,
  onClose,
  label,
  title,
  ...contentProps
}: LegalDocumentDialogProps) {
  return (
    <SwipableDialog
      open={open}
      onClose={onClose}
      headerText={contentProps.loading ? undefined : title}
      maxWidth="lg"
      aria-labelledby={undefined}
      aria-describedby={undefined}
      aria-label={label}
    >
      <LegalDocumentContent {...contentProps} />
    </SwipableDialog>
  );
}
